// Code generated by @hex-insights/frontend-generator; While this comment is present this file may be overwritten. If manual edits are made, remove this comment.
import { omitKeys } from "@hex-insights/core";
import {
	Country,
	EnrollmentApplication,
	EnrollmentApplicationGuardian,
	EnrollmentApplicationGuardianNameOrder,
	EnrollmentApplicationGuardianRelationshipStatus,
	Guardian,
} from "../../../Utilities";

export type Base = {
	givenName: EnrollmentApplicationGuardian["givenName"];
	middleName: EnrollmentApplicationGuardian["middleName"];
	familyName: EnrollmentApplicationGuardian["familyName"];
	nameOrder: EnrollmentApplicationGuardian["nameOrder"] | null;
	dateOfBirth: EnrollmentApplicationGuardian["dateOfBirth"] | null;
	gender: EnrollmentApplicationGuardian["gender"];
	relationshipType: EnrollmentApplicationGuardian["relationshipType"];
	relationshipStatus: EnrollmentApplicationGuardian["relationshipStatus"] | null;
	emailAddress: EnrollmentApplicationGuardian["emailAddress"];
	phoneNumber: EnrollmentApplicationGuardian["phoneNumber"];
	addressLine1: EnrollmentApplicationGuardian["addressLine1"];
	addressLine2: EnrollmentApplicationGuardian["addressLine2"];
	addressCity: EnrollmentApplicationGuardian["addressCity"];
	addressPostalCode: EnrollmentApplicationGuardian["addressPostalCode"];
	addressStateOrProvince: EnrollmentApplicationGuardian["addressStateOrProvince"];
	isPrimary: EnrollmentApplicationGuardian["isPrimary"];
	isFinancialContact: EnrollmentApplicationGuardian["isFinancialContact"];
	isEmergencyContact: EnrollmentApplicationGuardian["isEmergencyContact"];
	isAuthorizedForPickup: EnrollmentApplicationGuardian["isAuthorizedForPickup"];
	livesWithStudent: EnrollmentApplicationGuardian["livesWithStudent"];
	isPrimaryOnApplication: EnrollmentApplicationGuardian["isPrimaryOnApplication"];
	addressCountryID: Country["id"] | null;
	enrollmentApplicationID: EnrollmentApplication["id"] | null;
	guardianID: Guardian["id"] | null;
	targetAddressGuardianID: EnrollmentApplicationGuardian["id"] | null;
};

export type Create = Base;

export type CreateRequiredKey = Extract<
	keyof Create,
	"givenName" | "familyName" | "relationshipType" | "emailAddress" | "phoneNumber" | "enrollmentApplicationID"
>;

export type CreateSubset<K extends keyof Create = keyof Create> = Pick<Create, CreateRequiredKey | K>;

export const initialCreate: Create = {
	givenName: "",
	middleName: "",
	familyName: "",
	nameOrder: null,
	dateOfBirth: null,
	gender: "",
	relationshipType: "",
	relationshipStatus: null,
	emailAddress: "",
	phoneNumber: "",
	addressLine1: "",
	addressLine2: "",
	addressCity: "",
	addressPostalCode: "",
	addressStateOrProvince: "",
	isPrimary: false,
	isFinancialContact: false,
	isEmergencyContact: false,
	isAuthorizedForPickup: false,
	livesWithStudent: false,
	isPrimaryOnApplication: false,
	addressCountryID: null,
	enrollmentApplicationID: null,
	guardianID: null,
	targetAddressGuardianID: null,
};

export type Detail = Base & {
	name: EnrollmentApplicationGuardian["name"];
};

export type DetailSubset<K extends keyof Detail = keyof Detail> = Pick<Detail, K>;

export const nameOrderOptions = [
	{ value: EnrollmentApplicationGuardianNameOrder.FamilyGiven },
	{ value: EnrollmentApplicationGuardianNameOrder.GivenFamily },
];

export const relationshipStatusOptions = [
	{ value: EnrollmentApplicationGuardianRelationshipStatus.Married },
	{ value: EnrollmentApplicationGuardianRelationshipStatus.SeparatedOrDivorced },
	{ value: EnrollmentApplicationGuardianRelationshipStatus.Single },
	{ value: EnrollmentApplicationGuardianRelationshipStatus.TogetherButNotMarried },
];

export type CreateInEnrollmentApplication = Omit<Create, "enrollmentApplicationID">;

export type CreateInEnrollmentApplicationRequiredKey = Exclude<CreateRequiredKey, "enrollmentApplicationID">;

export type CreateInEnrollmentApplicationSubset<
	K extends keyof CreateInEnrollmentApplication = keyof CreateInEnrollmentApplication,
> = Pick<CreateInEnrollmentApplication, CreateInEnrollmentApplicationRequiredKey | K>;

export const blankItemInEnrollmentApplication: CreateInEnrollmentApplication = omitKeys(initialCreate, [
	"enrollmentApplicationID",
]);
